module.exports = __webpack_public_path__ + "static/djez_0-36ec9f427f2371eeb3f47a679207f629.jpg";